import React, { Component } from "react";
import HostFitnessScript from "./HostFitnessScript";
import HostControls from "./HostControls"; 
import ParticipantStreams from "./ParticipantStreams";
import HostNotes_MultiWindow from "./HostNotes_MultiWindow";
import ActivityMenu from "./ActivityMenu";
import ActivityVideo from "./ActivityVideo";
import ZoomedHost from "./ZoomedHost";
import CompleteSession from "./CompleteSession";
import SupportContainer from '../home/SupportContainer';
import ChatContainer from "./ChatContainer";
import ParticipantsList from "./ParticipantsList";
import TimerD2C from "./TimerD2C";
import FmPlayer from "./FmPlayer";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Util from "../../streaming/Util";
import $ from 'jquery';
import classnames from "classnames";

class InstructorD2C extends Component {
  
  constructor(props) {
		super(props);
		
		this.state={
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			userData: JSON.parse(localStorage.getItem('userData')),
			sessionData: JSON.parse(localStorage.getItem('userData')).sessionData,
			multi_window_status: true,
			sessionTime: '00 : 00',
			timeSpent: '00:00',
			sessionStarted: false,
			showStartScriptBtn: false,
			redTimer: false,
			tenSecRule: false,
			sessionScript: JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail,
			Notes_Callouts: [],
			Notes_CurrentActivity: {id: 'activity_1', payload: '', type: 'note'},
			showFmPlayer: false,
			scriptPaused: false,
			showBigClock: false,
			counterSec: 0,
			hiddenCaluclatingAR: true,
			dontShowInfo: "Don't show this again",
			recalibrationPopup: false
		}
		
		this.xInterval = null;
		window['stopScriptD2C'] = this.stopScriptD2C;
		this.playerFunctions = window['playerFunctions'];
		window['showPlayer'] = this.showPlayer;
		this.sessionDataStore = SessionDataStore.getInstance();
		window['addFeedFmToSessionData'] = this.addFeedFmToSessionData;
		window.calculatingAR = this.calculatingAR;
		window.disableCalculatingAR = this.disableCalculatingAR;
	}
 
	componentDidMount(){
		/*
		var mainData = JSON.parse(localStorage.getItem('userData'));
		
		if (mainData.isMarketplaceChannel === 1) 
			{
				this.setState({
					Notes_Callouts: this.props.mainthis.state.Notes_Callouts,
				});
			}
			*/	
	}
	
	componentWillUnmount(){
	}
	
	showPlayer=(mod)=>{
		this.setState({showFmPlayer: mod})
	}
		
	startClass=()=>{
		this.setState({
			sessionStarted: true,
			showBigClock: false,
		}, ()=>{
			window['sessionStarted'] = true;
			$("#mute_control").removeClass('d-none');
			$("#record_session").removeClass('d-none');
			this.props.mainthis.startSessionD2C();
			let mainthis = this;	
			if ( mainthis.state.sessionScript && mainthis.state.sessionScript.length > 0 )
				{
					mainthis.setState({
						showStartScriptBtn: true,
					});
				}
			else 
				{
					$('#startWork').addClass('d-none');
				}				
		});
	}
	
	startScript=()=>{
		
		if ( window['script_is_started'] )
			{
				$('#resumeButtonClick').trigger('click');
			}
		else
			{
				this.setState({
					showStartScriptBtn: false
				}, ()=>{
					$('#start_new_activity').trigger('click');
				});
				
				window['muteUnmute'](false);
			}
	}
	
	updateStateFromChild=(state)=>{
		this.props.mainthis.updateStateFromChild(state);
	}
	
	updateStateFromScript=(state)=>{
		this.setState(state);
	}
	
	showControls=()=>{
		$('#hostControlsD2C').removeClass('opacityHide');
	}

	showControls=()=>{
		$('#hostControlsD2C').removeClass('opacityHide');
	}
	
	stopScriptD2C=()=>{
		this.setState({
			showStartScriptBtn: true,
		});
	}
	
	addFeedFmToSessionData = (mod)=>{
		let action = 'Unmute';
		if ( mod )
			{
				action = 'Mute';
			}
		let addObject = {"sessionId": this.state.sessionData.id, "event": "feedFm", "eventType": "muteFeedFM", "userId": this.state.currentUserData.id, "details": JSON.stringify({"action": action}), "timestamp": Util.getCurrentTimestamp()};
		this.sessionDataStore.addSessionData(addObject);
	}
	
	calculatingAR=()=>{
		window['calculatingCalledAR'] = true;
		this.setState({
			hiddenCaluclatingAR: false
		},()=>{  });
	}
	
	disableCalculatingAR=()=>{
		this.setState({
			hiddenCaluclatingAR: true
		},()=>{  });
	}
	
	showRecalibrationPopup=()=>{
		this.setState({
			recalibrationPopup: true
		});
	}
	
	dontShowMessageAgain=()=>{
		this.disableCalculatingAR();
		this.recalibrationPopupAction(true);
	}
	
	recalibrationPopupAction = (mod) => {
		if ( mod )
			{
				var recalibrationObject = JSON.stringify({'sessionId': this.state.currentUserData.sessionData.id, 'value': true});
				localStorage.setItem('recalibrationHidden', recalibrationObject);
				//window['disableRecabToggle']();
			}
		else
			{
				var recalibrationObject = JSON.stringify({'sessionId': this.state.currentUserData.sessionData.id, 'value': false});
				localStorage.setItem('recalibrationHidden', recalibrationObject);
			}
		
		this.setState({
			recalibrationPopup: false
		});
	}
	
	render() {
		
		const pThis = this.props.mainthis;
	
		return (
		<>
			<div className={"host_stream_container " + (this.props.mainthis.state.rightMenuOpen ? "container_right_menu" : "")}>
				<div className={`topmost_layer ${this.props.mainthis.state.sessionStartedByHost ? 'display_none' : ''} `}>
					<ParticipantStreams
						state={this.props.mainthis.state}
						startSession={this.props.mainthis.startSession}
						showParticipantList={this.props.mainthis.showParticipantList}
						nextTutorial={this.props.mainthis.nextTutorial}
						backTutorial={this.props.mainthis.backTutorial}
						finishTutorial={this.props.mainthis.finishTutorial}
						startSessionInfo={this.props.mainthis.startSessionInfo}
						canStartSessionRTM={this.props.mainthis.state.canStartSessionRTM} 
						autoShowedMessage={this.props.mainthis.state.autoShowedMessage} 
						isSessionStarted={this.state.sessionStarted}
					></ParticipantStreams> 
				</div>
				<div className="instructorD2C" >
					<div className="upperHolderD2C" >
						<div className="headerD2C" >
							<TimerD2C 
							state={this.state}
							updateStateFromScript={this.updateStateFromScript}
							></TimerD2C>
							<div className="recording_on_d2c d-none" id="recordingon"></div>
							<div className="startBtnsHolderD2C">
								{/*
									<div className={"startBtnsD2C " + (this.state.sessionStarted ? "d-none" : "")} id="startClass" onClick={this.startClass}>Start Class</div>
									{ this.state.sessionStarted &&
										<div className="startBtnsD2C" id="startWork" onClick={this.startScript}>Start Script</div>
									}
								*/}
								<div className={(!this.state.showFmPlayer ? "d-none" : "inline")}>
									<FmPlayer></FmPlayer>
								</div>
							</div>
						</div>
						<div className="instructorStreamHolderD2C" >
							<div className={"instructorStreamD2C"} >
								<div id="host_video"></div>
								<div id="virtualmsg" className="screen_popup px-4 py-3 bg-grayy rounded text-white d-none"></div>
								<div id="canvasWrap" className="canvasHold d-none">
									<div className="equipment_stats_hold stats_hold_host d-none">
										<span className="inner_status_hold no_padd">
											<div>
												<div className="stats_image" id="repCountImagePar"></div>
												<div className="stats_value d-none" id="repcounter">0</div>
												<div className="stats_value d-none" id="repCountNegHost"></div>
											</div>
											<div id="secondStats">
												<div className="stats_image reverse_second_image" id="perCountImagePar"></div>
												<div className="stats_value ppm_count d-none" id="perMinuteCounter">
													<div className="counter-number ppm_value">0</div><div className="act-text ppm_text" style={{fontSize: '12px;'}} id="pmName"></div>
												</div>
											</div>
											<div>
												<div className="stats_image heart_stats"></div>
												<div className="stats_value ppm_count" id="heartStats">
													<div className="counter-number ppm_value">0</div><div className="act-text ppm_text" style={{fontSize: '12px;'}}>hr</div>
												</div>
											</div>
											<div>
												<div className="stats_image calories_image"></div>
												<div className="stats_value ppm_count" id="caloriesCount">
													<div className="counter-number ppm_value">0</div><div className="act-text ppm_text" style={{fontSize: '12px;'}}>kcal</div>
												</div>
											</div>
										</span>
									</div>
									<div id="showCalculatingAR" className={classnames("start_room_button_holder", { 'd-none': this.state.hiddenCaluclatingAR })}>
										<div className="room_setup_message_hold inside_session_button room_setup_message_small">
											<span className="calibration_ar_text ins_sep">Calibrating</span>
											<span className="calibration_ar_text d-inline-block">AR</span>
											<div className="room_setup_loader">
											  <div className="room_setup_loader_inner"></div>
											</div>
											<span className="calibration_ar_text out_of_frame ins_sep">Did you step out of frame?</span>
											<span className="calibration_ar_text out_of_frame dont_show_message pointer ins_sep" onClick={ () => this.dontShowMessageAgain()}>{this.state.dontShowInfo}</span>
										</div>
									</div>
									<span id="partToolTip" className="room_capturing_popup bg-grayy rounded d-none">
										<span className="separate_stats tool_tip_inner">
											<div className="room_setup_loader d-none">
												<div className="room_setup_loader_inner"></div>
											</div>
											<div className="tooltipImage"></div>
											<div id="upNextText" className="up_next d-none"></div>
											<div className="tooltipText rounded"></div>
											<div id="innerPartText" className="part_inner"></div>
											<div id="walkToolImage" className="walk_tool_hold d-none">
												<div className="walk_tool_image"></div>
												<div className="walk_tool_text"></div>
											</div>
											<div className="tooltipNumber d-none"></div>
										</span>
									</span>
									<div className="canvas-close-icon position-absolute d-none" close-id="" id="closeBtn"></div>
									<canvas className="canvasDraw" id="sessionCanvas" width="1280" height="720" oncontextmenu="return false"></canvas><canvas className="canvasGrid canvasImage" style={{transform: 'none !important'}} id="imageCanvas" width = "1280" height="720"></canvas><canvas className="canvasImage top100" id="bufferCanvas" width = "640" height="360"></canvas>
									<div className="canvasDot" id="editDot"></div>
								</div>
							</div>
							<div className={"alertPopD2C"} >
								<HostNotes_MultiWindow 
								state={this.props.mainthis.state} 
								startSession={this.state.sessionStarted}
								showStartScriptBtn={this.state.showStartScriptBtn }
								></HostNotes_MultiWindow>
							</div>
							
						</div>
					</div>
					<div className="fintessScriptD2C" >					
						<HostFitnessScript 
						state={this.state}
						updateStateFromChild={this.updateStateFromChild}	
						updateStateFromScript={this.updateStateFromScript}
						activityListOpen={this.props.mainthis.state.activityListOpen}
						></HostFitnessScript>
					</div>
					
					<div className={"hostControlsHolderD2C" + (this.state.showFmPlayer ? " nextToFM" : "")}>
						<div className="hostControlsHover" onMouseOver={this.showControls}>
							<div className="ctrlColorD2C" id='hostControlsD2C'>
								<HostControls
								mainthis={this}
								showBigClock={this.state.showBigClock}
								updateStateFromScript={this.updateStateFromScript}
								multiWindow={this.state.multi_window_status}
								pausedStatus={this.state.scriptPaused}
								showStartScriptBtn={this.state.showStartScriptBtn}
								sessionStarted={this.state.sessionStarted}
								sessionScript={this.state.sessionScript}
								state={pThis.state}
								updateStateFromChild={pThis.updateStateFromChild} 
								chatOpen={pThis.state.chatOpen}
								nextTutorial={pThis.nextTutorial}
								backTutorial={pThis.backTutorial}
								startClass={this.startClass}
								startScript={this.startScript}
								d2cClass={this.state.multi_window_status}
								showFmPlayer={this.state.showFmPlayer}
								></HostControls>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="chat_menu" className={(!this.props.mainthis.state.chatOpen ? "d-none" : "chat_container" )}>
				<ChatContainer updateStateFromChild={this.props.mainthis.updateStateFromChild}></ChatContainer>
			</div>
			<div className={(!this.props.mainthis.state.activityListOpen ? "d-none" : "left_container" )}>
				<ActivityMenu 
				state={this.props.mainthis.state}
				updateStateFromChild={this.props.mainthis.updateStateFromChild} 
				playActivityVideo={this.props.mainthis.playActivityVideo}>
				</ActivityMenu>
			</div>
			<ZoomedHost></ZoomedHost>
			{ this.props.mainthis.state.openLeave &&
				<CompleteSession updateStateFromChild={this.props.mainthis.updateStateFromChild} sessionName={this.props.mainthis.state.sessionData.name}></CompleteSession>
			}
			<SupportContainer supportPageName={this.props.mainthis.state.supportPageName} supportPageApi={this.props.mainthis.state.supportPageApi} userTypeFaqs={this.props.mainthis.state.userTypeFaqs}></SupportContainer>
			{ this.props.mainthis.state.openActivityVideo &&
				<ActivityVideo videoURL={this.props.mainthis.state.videoURL} updateStateFromChild={this.props.mainthis.updateStateFromChild}></ActivityVideo>
			}
			{this.state.showBigClock &&
				<div className="bigCountShow" >
					<div className="countNumD2C" >{this.state.counterSec}</div>
				</div>
			}
			<div className="holdPartList d-none" id="memebrsList">
				<ParticipantsList
					state={this.props.mainthis.state}
					showParticipantList={this.props.mainthis.showParticipantList}
					ejectParticipant={this.props.mainthis.ejectParticipant}
					updateStateFromChild={this.props.mainthis.updateStateFromChild}
				></ParticipantsList>
			</div>
			<div className="marq align-self-end flex-grow-1"><div className="particlecontainer-host"></div></div>
		</>
	)}
}
export default InstructorD2C;
